import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vue-stroke",
  "use": "icon-vue-stroke-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol viewBox=\"0 0 60 60\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vue-stroke\">\r\n<path d=\"M45.118 6.03461H36.1217L30.255 15.809L24.3686 6.03708L17.8326 6.03461H2.63373L30.297 53.2517L57.8096 6.03461H45.118ZM30.2847 43.4575L11.257 10.9749H18.2328L30.2995 31.7391L42.2723 10.9725H49.2135L30.2847 43.4575Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol